import { render, staticRenderFns } from "./aside-menu.vue?vue&type=template&id=4dfd9852&"
import script from "./aside-menu.vue?vue&type=script&lang=js&"
export * from "./aside-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "aside-menu.vue"
export default component.exports